<script>
  import { slide } from 'svelte/transition'
  import { Link, navigate } from 'svelte-routing'
  import ContactButtonAtom from '~/Components/Atoms/ContactButton'
  import store from '~/Library/store'

  function closeMobileMenu(){
    store.setAttribute('show_mobile_menu', false)
  }

  function logout(){
    store.reset() 
    navigate('/login', {replace: true})
  }

</script>

<div class="mobile__menu" transition:slide={{duration: 300}}>

  <img src="/static/icons/close-modal-dark.svg" on:click={closeMobileMenu} alt="" class="mobile__close">

  <!-- <h3 class="heading">

    <Link to="/">Next4me<span class="accent">.</span></Link>
    
  </h3> -->

  <ul on:click={closeMobileMenu}>

    <li>

      <Link to="/for-you">For you</Link>

    </li>

    <li>

      <Link to="/for-your-career">Your career</Link>

    </li>

    <li>

      <Link to="/mentors">Mentors</Link>

    </li>

  </ul>

  <ContactButtonAtom />

  <div>

  {#if $store.user}

    <img src="static/icons/logout.svg" on:click={logout} class="nav__logout" alt="">

  {/if}

  </div>

</div>

<style lang="scss">

  .mobile__menu {
    
    padding: 2rem 3rem;
    position: fixed;
    top: 0; 
    left: 0;
    height: 100vh;
    width: 100%; 
    box-sizing: border-box;
    background-color: white; 
    z-index: 20;

    h3 {
      margin-bottom: 2rem;
    }

    ul {
      
      list-style: none; 
      padding: 0px;
      margin: 1.5rem 0 4rem 0;

      li {
        display: block;
        margin-bottom: 1rem;
      }

    }

    hr {
      margin-bottom: 1rem;
    }

    > div {
      margin: 1rem 0;
    }

    .mobile__close {

      position: absolute;
      top: 1.5rem;
      right: 2.125rem;
      cursor: pointer;
      height: 1.25rem;
      width: 1.25rem;
      transition: transform .25s ease-in-out;
      stroke: red;

      &:hover {
        transform: rotate(180deg); 
      }

    }

  }

  :global(.mobile__menu ul li > a) {

    display: inline-block;
    color: var(--text-colour);
    position: relative;
    padding: 0.125rem 0;

    &[aria-current], &:hover {
      font-weight: medium;
      color: var(--heading-colour);
    }

    &[aria-current] {  
      border-bottom: 1px solid var(--heading-colour);
    }

  }

</style>